import { Route } from '@angular/router';

import { InitialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/home'
    { path: '', pathMatch: 'full', redirectTo: 'dashboard/home' },

    // Redirect signed-in user to the '/home'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

    // Auth routes for non-authenticated users
    {
        path: '',
        canMatch: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'forbidden', loadChildren: () => import('app/modules/auth/forbidden/forbidden.module').then(m => m.AuthConfirmationRequiredModule)},
            { path: 'start', loadChildren: () => import('app/modules/auth/start/start.module').then(m => m.AuthStartModule) },
            { path: 'start/callback', loadChildren: () => import('app/modules/auth/start/start.module').then(m => m.AuthStartModule) },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule) }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [                        
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule) },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule) }
        ]
    },

    // Admin routes for authenticated users
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            //{ path: 'application/usersearch1', loadChildren: () => import('app/modules/application/usersearch/usersearch.module').then(m => m.ApplicationUserSearchModule) },
            { path: 'application/apikeys', loadChildren: () => import('app/modules/application/apikey/apikeys.module').then(m => m.ApiKeysModule)},
            { path: 'application/usersearch', loadChildren: () => import('app/modules/application/contacts/contacts.module').then(m => m.ContactsModule)},
            { path: 'application/instancesearch', loadChildren: () => import('app/modules/application/instances/instances.module').then(m => m.InstancesModule)},
            { path: 'dashboard/home', loadChildren: () => import('app/modules/dashboard/home/home.module').then(m => m.DashboardHomeModule) }
        ]
    }
];
